<template>
    <div>
        <div class="modal hide fade" id="modalGetOnHand" tabindex="-1" role="dialog" aria-labelledby="modalGetOnHand" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title"><b>Stock Quantity - {{ product.product_no }}</b></h4>
                        <!-- <span>{{ state }}</span> -->
                        <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button> -->
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group row">
                                    <label for="quantity" class="col-sm-3 col-form-label text-left">Quantity</label>
                                    <div class="col-sm-9">
                                        <input class="form-control" type="text" id="quantity" v-model="pList.qty"/>
                                    </div>
                                </div>
                                <div class="form-group row">
                                  <label for="uom_id" class="col-sm-3 col-form-label text-left">Unit</label>
                                  <div class="col-sm-9">
                                    <select v-model="pList.uom_id" class="form-control">
                                      <option v-for="u in uomList" :key="u.id" :value="u.id">{{ u.name }}</option>
                                    </select>
                                  </div>
                                </div>
                                <div class="form-group row">
                                    <label for="price" class="col-sm-3 col-form-label text-left">Price</label>
                                    <div class="col-sm-9">
                                        <input v-model.lazy="pList.price" v-money="money" class="form-control">
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="on_hand_date" class="col-sm-3 col-form-label text-left">Date</label>
                                    <div class="col-sm-9">
                                        <datetime v-model="pList.on_hand_date" format="dd/MM/yyyy" class="form-control" value-zone="local" zone="local"></datetime>
                                    </div>
                                </div>
                                <div class="form-group row">
                                  <label for="warehouse_no" class="col-sm-3 col-form-label text-left">Warehouse</label>
                                  <div class="col-sm-9">
                                    <select v-model="pList.warehouse_no" class="form-control">
                                      <option v-for="w in warehouseList" :key="w.id" :value="w.warehouse_no">[{{ w.warehouse_no }}] {{ w.name }}</option>
                                    </select>
                                  </div>
                                </div>
                                <div class="form-group row">
                                  <label for="serial_number" class="col-sm-3 col-form-label text-left">Serial Number</label>
                                  <div class="col-sm-9">
                                    <input type="text" class="form-control" v-model="pList.serial_number"/>
                                  </div>
                                </div>
                                <div class="form-group row">
                                  <label for="sec_serial_number" class="col-sm-3 col-form-label text-left">Serial Number 2</label>
                                  <div class="col-sm-9">
                                    <input type="text" class="form-control" v-model="pList.sec_serial_number"/>
                                  </div>
                                </div>
                                <div class="form-group row">
                                  <label for="internal_no" class="col-sm-3 col-form-label text-left">Internal No.</label>
                                  <div class="col-sm-9">
                                    <input type="text" class="form-control" v-model="pList.internal_no"/>
                                  </div>
                                </div>
                                <div class="form-group row">
                                    <label for="price" class="col-sm-3 col-form-label text-left">Notes</label>
                                    <div class="col-sm-9">
                                        <textarea rows="5" class="form-control" v-model="pList.notes"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-hard-primary" data-dismiss="modal" @click="cancel">Cancel</button>
                      <button type="button" class="btn btn-soft-primary" data-dismiss="modal" @click="save">Save</button>
                    </div>
                </div>
            </div>
        </div>
    <!-- <pre>{{ pList }}</pre> -->
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ProductModalPrice',
  props: ['product', 'id', 'state'],
  data () {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      }
    }
  },
  computed: {
    ...mapState({
      warehouseList: state => state.warehouses.warehouseList,
      uomList: state => state.uom.uomList
    }),
    pList: function () {
      var obj
      var index = this.product.onHand.find(d => d.id === this.id)
      if (index) {
        return index
      } else {
        obj = {
          id: null,
          product_no: null,
          qty: null,
          price: '0',
          on_hand_date: null,
          notes: null,
          uom_id: null
        }
        return obj
      }
    }
  },
  methods: {
    save () {
      var p = this.product.onHand.find(d => d.id === this.id)
      if (this.pList.uom_id === null) {
        p.uom_id = this.product.uom_id
      } else {
        p.uom_id = this.pList.uom_id
      }
      p.state = this.state
      p.price = parseFloat(this.pList.price.replace(/\./g, ''))
      p.product_no = this.product.product_no
      console.log(p)
    },
    cancel () {
      if (this.state === 'create') {
        var index = this.product.onHand.findIndex(d => d.id === this.id)

        this.product.onHand.splice(index, 1)
      }
    }
  }
}
</script>
